import { render } from "./UIDateInput.vue?vue&type=template&id=1dc3519c"
import script from "./UIDateInput.vue?vue&type=script&lang=ts"
export * from "./UIDateInput.vue?vue&type=script&lang=ts"
script.render = render

export default script